import { FC } from 'react';

import { IconProps } from '.';

export const UpIcon: FC<IconProps> = ({
  width = 10,
  height = 5,
  color = '#737373',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.64638 0.146396L0.646417 3.14636C0.552667 3.24012 0.5 3.36729 0.5 3.49988C0.5 3.63247 0.552667 3.75963 0.646417 3.8534C0.740181 3.94715 0.867344 3.99981 0.999937 3.99981C1.13253 3.99981 1.25969 3.94715 1.35346 3.8534L3.99992 1.20693L6.64639 3.8534C6.74016 3.94715 6.86732 3.99981 6.99991 3.99981C7.1325 3.99981 7.25967 3.94715 7.35343 3.8534C7.44718 3.75963 7.49985 3.63247 7.49985 3.49988C7.49985 3.36729 7.44718 3.24012 7.35343 3.14636L4.35347 0.146396C4.2597 0.0526583 4.13254 0 3.99995 0C3.86736 0 3.74015 0.0526583 3.64638 0.146396Z"
      fill={color}
    />
  </svg>
);
export const DownIcon: FC<IconProps> = ({
  width = 10,
  height = 5,
  color = '#737373',
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 8 4"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.999927 0C0.867328 2.03626e-05 0.740168 0.0527113 0.646416 0.146483C0.552667 0.240248 0.5 0.367411 0.5 0.500004C0.5 0.632596 0.552667 0.75976 0.646416 0.853524L3.64638 3.85349C3.74015 3.94722 3.86731 3.99988 3.9999 3.99988C4.13249 3.99988 4.25965 3.94722 4.35342 3.85349L7.35338 0.853524C7.44713 0.75976 7.4998 0.632596 7.4998 0.500004C7.4998 0.367411 7.44713 0.240248 7.35338 0.146483C7.25962 0.0527334 7.13245 6.67564e-05 6.99986 6.67564e-05C6.86727 6.67564e-05 6.74011 0.0527334 6.64634 0.146483L3.99987 2.79295L1.35341 0.146483C1.25966 0.0527113 1.13253 2.03626e-05 0.999927 0Z"
      fill={color}
    />
  </svg>
);
